// import { PermissionKey } from '@com/enums/user'
import Layout from '../views/layout/index.vue'
import i18n from '@/lang'
// import { hasPermission } from '../plugins/permission-manager/manager'
// import { generateConfigRoute } from '@com/utils/generateConfigRoute'
// import PtLayout from '@pt/views/layout/index.vue'

export const billingRoute = [
  {
    path: 'usage',
    name: 'account-management.billing.usage',
    component: () => import('@pt/views/account-management/billing/usage.vue'),
    meta: {
      title: i18n.t(
        'playTurbo.leftMenu.aside.menu.accountManagement.billing.usage',
      ),
      defaultPath: '/account-management/billing',
    },
  },
  {
    path: 'materials',
    name: 'account-management.billing.materials',
    component: () =>
      import('@pt/views/account-management/billing/materials.vue'),
    meta: {
      title: i18n.t(
        'playTurbo.leftMenu.aside.menu.accountManagement.billing.materials',
      ),
      defaultPath: '/account-management/billing',
    },
  },
]

export default {
  path: '/account-management',
  component: Layout,
  redirect: 'noredirect',
  name: 'account-management',
  icon: 'ic_account_management',
  meta: {
    title: i18n.t('playTurbo.leftMenu.aside.menu.accountManagement.name'),
  },
  children: [
    {
      path: 'finance',
      name: 'account-management.finance',
      redirect: '/account-management/finance/bill',
      component: () =>
        import('@pt/views/account-management/finance-bill/index.vue'),
      meta: {
        title: i18n.t('playTurbo.billing.bills.menu'),
        defaultPath: '/account-management/finance',
      },
      children: [
        {
          path: 'bill',
          name: 'account-management.finance.bill',
          component: () =>
            import(
              '@pt/views/account-management/finance-bill/bill-overview.vue'
            ),
          meta: {
            title: i18n.t('playTurbo.billing.bills.title'),
            defaultPath: '/account-management/finance',
          },
        },
        {
          path: 'statement',
          name: 'account-management.finance.statement',
          component: () =>
            import(
              '@pt/views/account-management/finance-bill/bill-statement.vue'
            ),
          meta: {
            title: i18n.t('playTurbo.billing.bills.statement'),
            defaultPath: '/account-management/finance',
          },
        },
      ],
    },
    {
      path: 'finance/bill/detail',
      name: 'account-management.finance.bill.detail',
      hidden: true,
      component: () =>
        import('@pt/views/account-management/finance-bill/detail.vue'),
      meta: {
        title: i18n.t('playTurbo.billing.bills.title'),
        defaultPath: '/account-management/finance',
      },
    },
    {
      path: 'payment',
      name: 'account-management.payment',
      component: () =>
        import('@pt/views/account-management/payment-record/index.vue'),
      meta: {
        title: i18n.t('playTurbo.payment.record.page.title'),
        defaultPath: '/account-management/payment',
        payment: 'free',
      },
    },
    {
      path: 'billing',
      name: 'account-management.billing',
      redirect: 'billing/usage',
      component: () => import('@pt/views/account-management/billing/index.vue'),
      meta: {
        title: i18n.t('playTurbo.billing.usage.title'),
        defaultPath: '/account-management/billing',
      },
      children: billingRoute,
    },
  ],
}
